/**
 * Подставляет полный URL API для img с src="/api/wiki/...",
 * чтобы картинки грузились с бэкенда (например localhost:8080), а не с текущего origin.
 */
import { WIKI_CONFIG } from '../config';

const BASE = (WIKI_CONFIG.apiUrl || '').replace(/\/$/, '');

export function ensureWikiImageUrls(html) {
  if (!html || !BASE) return html || '';
  return String(html).replace(
    /(src=")(\/api\/wiki\/[^"]*")/gi,
    (_, attr, path) => `${attr}${BASE}${path}`
  );
}

/**
 * Обрабатывает HTML контента вики для отображения: подставляет URL картинок,
 * для img без width/height добавляет класс для резервирования места (aspect-ratio).
 */
export function processWikiContentImages(html) {
  if (!html || typeof html !== 'string') return html || '';
  let out = ensureWikiImageUrls(html);
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(out, 'text/html');
    const imgs = doc.body.querySelectorAll('img');
    imgs.forEach((img) => {
      /* Не ставим loading="lazy" — в части браузеров картинки при скролле пропадали. */
      const hasWidth = img.hasAttribute('width');
      const hasHeight = img.hasAttribute('height');
      if (!hasWidth && !hasHeight) {
        img.classList.add('wiki-img-no-dimensions');
      }
    });
    return doc.body.innerHTML;
  } catch (_) {
    return out;
  }
}

/** Возвращает полный URL для вставки в редактор (тот же origin, что и API). */
export function getFullImageUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return BASE ? `${BASE}${path}` : path;
}
